// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-cart-screen>h1,.empty-cart-screen>p,.empty-cart-screen>a{text-align:center;color:var(--secondary-text-color)}.empty-cart-screen>p>a,.empty-cart-screen>p>a:visited{color:var(--main-brand-color);text-decoration:none}.empty-cart-screen>h1{margin-bottom:1.5rem}.empty-cart-screen>p{margin-bottom:3rem}\n", ""]);
// Exports
module.exports = exports;
